import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { tracked } from '@glimmer/tracking';

import type { DSSetup, PopupData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import GoalSelectorComponent from 'webapp/components/goal/selector';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class GoalPopupSelectorComponent extends PopupInnerModalComponent<PopupData.Goal.Selector> {
	@tracked selectedGoalMetricData: DSSetup.MetricData | null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.selectedGoalMetricData = this.popupData.selectedGoalMetricData;
	}

	@action
	changeSelectedMetricData(metricData: DSSetup.MetricData | null) {
		this.selectedGoalMetricData = metricData;
	}

	@action
	save() {
		this.popupData.onSave(this.selectedGoalMetricData);
		this.close();
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="OkRs" @size="lg" />
			Select goal
		</div>
		<div class="content">

			<div class="row">

				{{#if this.popupData.textLabel}}
					<p>{{{this.popupData.textLabel}}}</p>
				{{/if}}

				<GoalSelectorComponent
					@selectedGoalMetricData={{this.selectedGoalMetricData}}
					@metricSetup={{this.popupData.metricSetup}}
					@onChange={{this.changeSelectedMetricData}}
					@skipGoals={{this.popupData.skipGoals}}
					@disableGoalsInfo={{this.popupData.disableGoalsInfo}}
					@origin="designer"
					@isGoalTypeObjectiveDisabled={{this.popupData.isGoalTypeObjectiveDisabled}}
				/>
			</div>

			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Cancel"
						@theme="grey-empty"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
					<SubmitButtonComponent
						@text="Save"
						@extraClass="save"
						@onTrigger={{this.save}}
					/>
				</div>
			</div>
		</div>
	</template>
}
